<template>
  <div class="site-container site-section-v">
    <form-contact>
      <template #form-top>
        <h2 class="text-orange" style="margin-bottom: 3rem">
          Entre em Contato
        </h2>
        <p>
          Fale com a gente como preferir, estamos sempre dispostos a ajudar
          você.
        </p>
      </template>
      <template #info>
        <div class="contact-info">
          <h2 class="text-orange" style="margin-bottom: 1.5rem">
            Agendamento Online
          </h2>
          <div class="contact-info-item">
            <p>
              Disponibilizamos o atendimento telepresencial para facilitar o contato com o escritório. Clique no botão
              abaixo e agende o melhor horário para falar conosco.
            </p>
            <router-link :to="{ name: 'page_online_scheduling' }" class="button button button-orange">
              <img class="icon" src="@/assets/img/svg/white_calendar.svg" />
              AGENDAMENTO ONLINE
            </router-link>
          </div>
          <div class="contact-info-item">
            <a class="button button-orange" href="https://api.whatsapp.com/send?phone=551133760100" target="_blank">
              <img class="icon" src="@/assets/img/svg/white_whatsapp.svg" />
              ENVIE UMA MENSAGEM
            </a>
          </div>
          <div class="contact-info-item">
            <h4>
              <img src="@/assets/img/svg/whatsapp.svg" width="20" />
              TELEFONE
            </h4>
            <p>
              <span class="big">(11) 3376-0100</span> - Matriz<br />Atendimento
              de segunda a sexta das 8h às 17h
            </p>

            <h4><img src="@/assets/img/svg/email.svg" width="20" />E-MAIL</h4>
            <p><span class="big">atendimento@crivelli.com.br</span></p>
          </div>
        </div>
      </template>
    </form-contact>
    <hr />

    <div class="site-section-v">
      <h2 class="text-orange text-center">Unidades</h2>
    </div>

    <location v-for="item in addresses" :key="item.city" v-bind="item" />

    <hr />
    <download-app />
  </div>
</template>

<script>
import FormContact from "@/components/FormContact";
import DownloadApp from "@/components/Home/DownloadApp";
import Location from "@/components/Location";

export default {
  components: { DownloadApp, FormContact, Location },

  computed: {
    addresses() {
      return [
        {
          city: "São Paulo",
          address:
            "Rua Boa Vista, 254, 12º andar, Cj. 1209\nCentro - CEP 01014.000 - São Paulo/SP",
          phone: "(11) 3376-0100",
          url: "https://goo.gl/maps/LNjuuijywVMdz5ny8",
          iframe:
            "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3657.6401605825645!2d-46.63564978502232!3d-23.545441384690754!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x94ce5855a750c411%3A0x6862df49b06388fe!2sR.%20Boa%20Vista%2C%20254%20-%2012%C2%BA%20andar%2C%20Cj.%201209%20-%20Centro%20Hist%C3%B3rico%20de%20S%C3%A3o%20Paulo%2C%20S%C3%A3o%20Paulo%20-%20SP%2C%2001202-001!5e0!3m2!1spt-BR!2sbr!4v1613397586232!5m2!1spt-BR!2sbr",
        },
        {
          city: "Brasília",
          address:
            "SAUS Quadra 5 Bloco K, SALA 903-904, Cj. 11\nAsa Sul - CEP 70070.050 - Brasília/DF",
          url: "https://goo.gl/maps/VF31vZEpZgbHrTTN8",
          phone: "(61) 3323-4924",
          iframe:
            "https://www.google.com/maps/embed?pb=!1m14!1m8!1m3!1d15355.93491178345!2d-47.881295!3d-15.804812!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x0%3A0x1ebda5bcef5a60d0!2sCrivelli%20Advogados!5e0!3m2!1spt-BR!2sbr!4v1613398005020!5m2!1spt-BR!2sbr",
        },
        {
          city: "Ribeirão Preto",
          address:
            "Av. Presidente Vargas, 2121, Cj. 2302, Sala 09\nSanta Angela - CEP 14020.260 - Ribeirão Preto/SP",
          url: "https://g.page/crivelliadvogados?share",
          phone: "(16) 3602-8494",
          iframe:
            "https://www.google.com/maps/embed?pb=!1m14!1m8!1m3!1d6256.235219849676!2d-47.8072481777982!3d-21.192989058589358!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x0%3A0xe3053de12a1e3fa7!2sCrivelli%20Advogados%20Associados!5e0!3m2!1spt-BR!2sbr!4v1627845999562!5m2!1spt-BR!2sbr",
        },
        {
          city: "Osasco",
          address:
            "R. Presidente Castelo Branco, 45, Salas 709/710\nCentro - CEP 06013.070 - Osasco/SP",
          url: "https://goo.gl/maps/PMw5MDqGLRerTUZj9",
          phone: "(11) 4620-0644",
          iframe:
            "https://www.google.com/maps/embed?pb=!1m14!1m8!1m3!1d14631.57399978131!2d-46.7764574!3d-23.5363326!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x0%3A0x1129f3a19b145bc1!2sCrivelli%20Advogados!5e0!3m2!1spt-BR!2sbr!4v1613398082052!5m2!1spt-BR!2sbr",
        },
        {
          city: "São Paulo Funchal",
          address:
            "Rua Funchal, 418 – 35º andar\nVila Olímpia – CEP 04551-060 - São Paulo/SP",
          url: "https://goo.gl/maps/uYGp5kLhfKV2tp2V8",
          phone: "(11) 3521-7061",
          iframe:
            "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3656.287697842677!2d-46.6900121!3d-23.5940129!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x94ce5738791c3353%3A0x5c3f37c72d129540!2sR.%20Funchal%2C%20418%20-%2035%C2%BA%20andar%20-%20Vila%20Ol%C3%ADmpia%2C%20S%C3%A3o%20Paulo%20-%20SP%2C%2004551-050!5e0!3m2!1spt-BR!2sbr!4v1685533101810!5m2!1spt-BR!2sbr",
        },
        {
          city: "Santo André",
          address:
            "R. Dona Elisa Fláquer, 70 - Cjto 136 - Centro, Santo André - SP, 09020-160",
          url: "https://maps.app.goo.gl/X7nJ8EyTwYzVS98FA",
          phone: "(11) 3376-0100",
          iframe:
            "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d4345.945657923349!2d-46.52962763874242!3d-23.658424299958092!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x94ce432f78239e8d%3A0x89db415f9676fd23!2sCrivelli%20Advogados%20Associados!5e0!3m2!1spt-BR!2sbr!4v1758052884398!5m2!1spt-BR!2sbr",
        },
      ];
    },
  },
};
</script>

<style>
</style>
